export const extractPythonTestResponseData = (testResponse: unknown) => {
  if (
    testResponse &&
    typeof testResponse === 'object' &&
    !Array.isArray(testResponse) &&
    ('response' in testResponse || 'data' in testResponse)
  ) {
    const wrappedResponse = testResponse as { response?: unknown; data?: unknown };
    if (wrappedResponse.response !== undefined) {
      return wrappedResponse.response;
    }
    if (wrappedResponse.data !== undefined) {
      return wrappedResponse.data;
    }
  }

  return testResponse;
};

export const formatPythonTestResponse = (testResponse: unknown) => {
  const responseData = extractPythonTestResponseData(testResponse);

  if (responseData === undefined) {
    return 'No output returned.';
  }

  if (typeof responseData === 'string') {
    try {
      return JSON.stringify(JSON.parse(responseData), null, 4);
    } catch (error) {
      return JSON.stringify(responseData, null, 4);
    }
  }

  if (
    responseData === null ||
    typeof responseData === 'number' ||
    typeof responseData === 'boolean' ||
    Array.isArray(responseData) ||
    typeof responseData === 'object'
  ) {
    return JSON.stringify(responseData, null, 4);
  }

  return String(responseData);
};
